<p-confirmDialog key="camera-error-confirm" class="custom-confirm"></p-confirmDialog>

<div class="webcam-container" [ngClass]="!webcamImage ? 'block' : 'hidden'">
        <webcam *ngIf="deviceId" #webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                [allowCameraSwitch]="false" [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions"
                [imageQuality]="1" (initError)="handleInitError($event)"></webcam>
        <div class="flex absolute bottom-0 w-full pr-6 justify-content-evenly flex-wrap b-3rem">
                <button pButton pRipple type="button" icon="pi pi-arrow-left"
                        class="p-button-rounded p-button-secondary" (click)="cancel()"
                        [disabled]="disabledCancel"></button>
                <button pButton pRipple type="button" icon="pi pi-camera" class="p-button-rounded"
                        (click)="triggerSnapshot()" [disabled]="disabledSnapshot"></button>
        </div>
</div>
<div class="flex-column webcam-container" [ngClass]="webcamImage ? 'flex' : 'hidden'">
        <img [src]="webcamImage?.imageAsDataUrl" alt="ticket" class="flex-grow-1 flex" height="91%">
        <div class="flex flex-shrink-0 justify-content-evenly flex-wrap">
                <button pButton pRipple label="Cancelar" class="p-button-outlined p-button-secondary mt-4"
                        icon="pi pi-arrow-left" (click)="resetCamera()"></button>
                <button pButton pRipple label="Aceptar" class="p-button-outlined mt-4" icon="pi pi-check"
                        (click)="saveData()"></button>
        </div>
</div>